import { render, staticRenderFns } from "./SelfPperatedField.vue?vue&type=template&id=54e4fd0e"
import script from "./SelfPperatedField.vue?vue&type=script&lang=ts"
export * from "./SelfPperatedField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports